import { render, staticRenderFns } from "./remove-login-dialog-and-button.vue?vue&type=template&id=4f230ef3"
import script from "./remove-login-dialog-and-button.vue?vue&type=script&lang=js"
export * from "./remove-login-dialog-and-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports